/* Experiencia "así se usa": pasos que se tocan y avanzan solos mientras se ven.
   - Con foto por paso: como historias (foto real a pantalla, barras arriba, tocar a la derecha/izquierda).
   - Sin fotos por paso: la foto del producto y los pasos en tarjetas numeradas que se van marcando.
   Datos: [ { "titulo": "Ábrelo", "texto": "...", "foto": 3 }, ... ]  (nayhogar.pasos)
      o   { "tipo": "asi-se-usa", "foto": 2, "pasos": [ "Paso en una frase", { "titulo": "...", "texto": "...", "foto": 4 } ] } */
NHX.registrar('asi-se-usa', function (root, d, x) {
  const P = x.producto();
  const lista = Array.isArray(d) ? d : (Array.isArray(d.pasos) ? d.pasos : (Array.isArray(P.pasos) ? P.pasos : (P.pasos && Array.isArray(P.pasos.pasos) ? P.pasos.pasos : [])));
  const pasos = lista.map(p => typeof p === 'string' ? { t: p, tx: '', f: null } : { t: p.titulo || '', tx: p.texto || '', f: x.foto(p.foto) || null }).filter(p => p.t || p.tx);
  if (pasos.length < 2) return false;
  const conFotos = pasos.filter(p => p.f).length >= 2;
  const fotoBase = x.foto((!Array.isArray(d) && d.foto) || 1);
  const DUR = conFotos ? 5200 : 4200;
  const n2 = i => String(i + 1).padStart(2, '0');

  if (conFotos) {
    root.innerHTML =
      '<div class="xus">' +
        '<div class="xus__stage nhx-stage" tabindex="0" aria-roledescription="carrusel" aria-label="Pasos de uso">' +
          '<div class="xus__bars" aria-hidden="true">' + pasos.map(() => '<span><i></i></span>').join('') + '</div>' +
          pasos.map((p, i) => '<figure class="xus__slide' + (i === 0 ? ' on' : '') + '" aria-hidden="' + (i !== 0) + '">' +
            x.imgTag(p.f || fotoBase, 'xus__img' + (p.f ? '' : ' nhx-prod is-prod'), { alt: p.t }) + '</figure>').join('') +
          '<button type="button" class="xus__tap xus__tap--prev" aria-label="Paso anterior"></button><button type="button" class="xus__tap xus__tap--next" aria-label="Paso siguiente"></button>' +
          '<div class="xus__cap" aria-live="polite"><b class="xus__n"></b><div><h3 class="xus__t"></h3><p class="xus__tx"></p></div></div>' +
          x.pista('Toca para avanzar', 'toca') +
        '</div>' +
        '<ol class="xus__list">' + pasos.map((p, i) => '<li><button type="button" data-i="' + i + '"><span>' + n2(i) + '</span><b>' + x.esc(p.t) + '</b></button></li>').join('') + '</ol>' +
      '</div>';
  } else {
    root.innerHTML =
      '<div class="xus xus--lista">' +
        '<div class="xus__stage nhx-stage">' + (fotoBase ? x.imgTag(fotoBase, 'xus__img nhx-prod is-prod') : '') + '<b class="xus__big" aria-hidden="true">01</b></div>' +
        '<ol class="xus__pasos">' + pasos.map((p, i) => '<li><button type="button" data-i="' + i + '"><span class="xus__pn">' + n2(i) + '</span><span class="xus__pt"><b>' + x.esc(p.t) + '</b>' + (p.tx ? '<small>' + x.esc(p.tx) + '</small>' : '') + '</span><i class="xus__pb"><i></i></i></button></li>').join('') + '</ol>' +
      '</div>';
  }
  const st = root.querySelector('.xus__stage');
  const slides = Array.from(st.querySelectorAll('.xus__slide'));
  const bars = conFotos ? Array.from(st.querySelectorAll('.xus__bars i')) : Array.from(root.querySelectorAll('.xus__pb i'));
  const btns = Array.from(root.querySelectorAll('[data-i]'));
  let i = 0, prog = 0, last = 0, corriendo = false, pausa = false, raf = 0;
  function ir(n, manual) {
    i = (n + pasos.length) % pasos.length;
    prog = 0;
    slides.forEach((s, k) => { s.classList.toggle('on', k === i); s.setAttribute('aria-hidden', k !== i); });
    bars.forEach((b, k) => { b.style.transform = 'scaleX(' + (k < i ? 1 : 0) + ')'; });
    btns.forEach((b, k) => { b.setAttribute('aria-current', k === i ? 'step' : 'false'); b.classList.toggle('is-hecho', k < i); });
    if (conFotos) {
      st.querySelector('.xus__n').textContent = n2(i);
      st.querySelector('.xus__t').textContent = pasos[i].t;
      st.querySelector('.xus__tx').textContent = pasos[i].tx;
    } else {
      st.querySelector('.xus__big').textContent = n2(i);
    }
    st.classList.remove('is-cap'); void st.offsetWidth; st.classList.add('is-cap');
    if (manual) st.classList.add('is-tocado');
  }
  function tick(t) {
    if (!corriendo) return;
    const dt = last ? t - last : 0; last = t;
    if (!pausa) {
      prog += dt / DUR;
      if (bars[i]) bars[i].style.transform = 'scaleX(' + Math.min(1, prog) + ')';
      if (prog >= 1) ir(i + 1);
    }
    raf = requestAnimationFrame(tick);
  }
  ir(0);
  const prev = st.querySelector('.xus__tap--prev'), next = st.querySelector('.xus__tap--next');
  if (prev) prev.addEventListener('click', () => ir(i - 1, true));
  if (next) next.addEventListener('click', () => ir(i + 1, true));
  btns.forEach(b => b.addEventListener('click', () => ir(+b.dataset.i, true)));
  st.addEventListener('keydown', e => { if (e.key === 'ArrowRight') { e.preventDefault(); ir(i + 1, true); } if (e.key === 'ArrowLeft') { e.preventDefault(); ir(i - 1, true); } });
  const zona = conFotos ? st : root;
  zona.addEventListener('pointerenter', () => { if (x.fino) pausa = true; });
  zona.addEventListener('pointerleave', () => { pausa = false; });
  st.addEventListener('pointerdown', () => { pausa = true; });
  st.addEventListener('pointerup', () => { pausa = false; });
  if (!x.reduce && 'IntersectionObserver' in window) {
    new IntersectionObserver(es => es.forEach(en => {
      if (en.isIntersecting) { if (!corriendo) { corriendo = true; last = 0; raf = requestAnimationFrame(tick); } }
      else { corriendo = false; cancelAnimationFrame(raf); }
    }), { threshold: 0.5 }).observe(st);
  }
});
